<div mat-dialog-title>
  <h2>{{"auth.Print Till" | translate}}</h2>

  <button mat-icon-button class="close" mat-dialog-close [disabled]="loading">
    <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div class="mat-dialog-body">

    <mat-form-field class="mb-4" [class.loading-field]="usersLoading" *ngIf="data.isOwner" hideRequiredMarker>
      <mat-label>{{ 'reports.Cashier' | translate }}</mat-label>
      <mat-select [formControl]="userId">
        <mat-option *ngFor="let user of users" [value]="user.id">
          {{user.name}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="userId.hasError('required')">
        {{ 'auth.Please select cashier' | translate }}</mat-error>
    </mat-form-field>


    <p class="mb-3 text-center">{{'auth.Please enter till amount' | translate}}</p>
    <mat-form-field hideRequiredMarker>
      <mat-label>{{ 'auth.Till amount' | translate }}</mat-label>
      <input matInput [formControl]="tillAmount" maxlength="10">
      <mat-error *ngIf="tillAmount.hasError('required')">
        {{ 'forms.Required' | translate }}</mat-error>
      <mat-error *ngIf="tillAmount.hasError('pattern')">
          {{ 'forms.Invalid value' | translate }}
      </mat-error>
    </mat-form-field>

  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close type="button" class="btn-grey" [disabled]="loading">{{"forms.Cancel" | translate}}</button>

  <button mat-raised-button color="primary" [disabled]="loading" [class.loading]="loading" (click)="submit()">
    {{"swalMsg.Ok" | translate}}
  </button>
</mat-dialog-actions>
